import { render, staticRenderFns } from "./AlertAcquisto.vue?vue&type=template&id=1e5e1ed8"
import script from "./AlertAcquisto.vue?vue&type=script&lang=js"
export * from "./AlertAcquisto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports